import { z } from 'zod/v4'
import { useMesaDynamicConfig } from '@/src/services/Statsig/useMesaDynamicConfig'

export const PointsToStatementCreditSchema = z.object({
  statement_credit_cents_per_point: z.number(),
})

export type PointsToStatementCredit = z.infer<typeof PointsToStatementCreditSchema>

export function usePointsToStatementCreditDynamicConfig() {
  return useMesaDynamicConfig('statement_credit_')
}
